<template>
  <div>
    <v-card>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :loading="loading"
          :items="displayData"
          disable-pagination
          disable-filtering
          :disable-sort="displayData.length <= 4"
          dense
          hide-default-footer
          :sort-by="['charges']"
          :sort-desc="[true]"
        >
          <template v-slot:item="{ item }">
            <tr v-if="item.name == 'Total'">
              <td style="color: #fc8f00; font-weight: bold">
                {{ item.name }}
              </td>
              <td style="color: #fc8f00; font-weight: bold; text-align: end">
                {{ item.charges | billingFormatter }}
              </td>
            </tr>
            <tr v-else>
              <td @click="filterItem(item)">{{ item.name }}</td>
              <td>
                {{ item.charges | billingFormatter }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  //| cpmFormat
  import { mapGetters } from 'vuex'
  import * as formatters from '@/components/common/formatters.js'
  export default {
    filters: {
      impressionsFormat(item) {
        return formatters.impressionsFormatter(item)
      },
      revenueFormatter(item) {
        return formatters.revenueFormatter(item)
      },
      billingFormatter(item) {
        return formatters.billingFormatter(item)
      },
      ucFirst(item) {
        return formatters.ucFirst(item)
      }
    },
    // eslint-disable-next-line vue/require-prop-types
    props: ['category', 'reportingData', 'loading', 'period'],
    data() {
      return {
        categoryReplace: this.category.replace('_', ' '),
        headers: [
          { text: 'Name', value: 'name', width: '80%' },
          { text: 'Charges', value: 'charges' }
        ]
      }
    },
    computed: {
      ...mapGetters(['appCustomer', 'selectedCustomer']),
      displayData() {
        var parsedobj = JSON.parse(JSON.stringify(this.reportingData))
        for (let i = 0; i < parsedobj.length; i++) {
          parsedobj[i].charges =
            (parseInt(parsedobj[i].auctions) * parsedobj[i].cpm) / 1000
          if (parsedobj[i].name == 'Others') {
            if (parsedobj[i].auctions == null) {
              const index = parsedobj.findIndex(
                (item) => item.name === 'Others'
              )
              parsedobj.splice(index, 1)
              break
            }
          }
        }
        if (parsedobj[0] != undefined) {
          var totalcharges = 0
          for (let i = 0; i < parsedobj.length; i++) {
            totalcharges = totalcharges + parseFloat(parsedobj[i].charges)
          }
          parsedobj.splice(0, 0, {
            id: 'total',
            name: 'Total',
            charges: totalcharges
          })
          return parsedobj.map((data) => {
            if (data.name == 'amp') data.name = 'Nexx AMP'
            if (data.name == 'fast') data.name = 'Nexx Web'
            if (data.name == 'adapter') data.name = 'Nexx Adapter'
            return data
          })
        }

        return parsedobj.map((data) => {
          if (data.name == 'amp') data.name = 'Nexx AMP'
          if (data.name == 'fast') data.name = 'Nexx Web'
          if (data.name == 'adapter') data.name = 'Nexx Adapter'
          return data
        })
      }
    },
    watch: {
      appCustomer: async function (val, oldVal) {}
    },
    methods: {
      filterItem(item) {
        const filter = {
          category: this.category,
          id: item.id
        }
        if (filter['id'] != '0' && filter['id'] != 'N/A')
          this.$emit('filter', filter)
      }
    }
  }
</script>
